import type { AjustarProjecaoTransferenciaDialogProps } from "./types-ajustar-projecao-transferencia-dialog";
import { useAjustarProjecaoTransferenciaDialog } from "./use-ajustar-projecao-transferencia-dialog";
import { AjustarProjecaoTransferenciaDialogView } from "./view-ajustar-projecao-transferencia-dialog";

export function AjustarProjecaoTransferenciaDialog(props: AjustarProjecaoTransferenciaDialogProps) {
  const vm = useAjustarProjecaoTransferenciaDialog(props);

  return <AjustarProjecaoTransferenciaDialogView {...vm} />;
}

export type * from "./types-ajustar-projecao-transferencia-dialog";
